import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M9.70711 4.70711C10.0976 4.31658 10.0976 3.68342 9.70711 3.29289C9.31658 2.90237 8.68342 2.90237 8.29289 3.29289L3.29289 8.29289C2.90237 8.68342 2.90237 9.31658 3.29289 9.70711C3.68342 10.0976 4.31658 10.0976 4.70711 9.70711L9.70711 4.70711Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M14.2929 4.70711C13.9024 4.31658 13.9024 3.68342 14.2929 3.29289C14.6834 2.90237 15.3166 2.90237 15.7071 3.29289L20.7071 8.29289C21.0976 8.68342 21.0976 9.31658 20.7071 9.70711C20.3166 10.0976 19.6834 10.0976 19.2929 9.70711L14.2929 4.70711Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M8 11.9189C8.55228 11.9189 9 12.3667 9 12.9189V15.9189C9 16.4712 8.55228 16.9189 8 16.9189C7.44772 16.9189 7 16.4712 7 15.9189V12.9189C7 12.3667 7.44772 11.9189 8 11.9189Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M16 11.9189C16.5523 11.9189 17 12.3667 17 12.9189V15.9189C17 16.4712 16.5523 16.9189 16 16.9189C15.4477 16.9189 15 16.4712 15 15.9189V12.9189C15 12.3667 15.4477 11.9189 16 11.9189Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  d: "M12 11.9189C12.5523 11.9189 13 12.3667 13 12.9189V15.9189C13 16.4712 12.5523 16.9189 12 16.9189C11.4477 16.9189 11 16.4712 11 15.9189V12.9189C11 12.3667 11.4477 11.9189 12 11.9189Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4 8C3.44772 8 3 8.44772 3 9V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V9C21 8.44772 20.5523 8 20 8H4ZM5 18V10H19V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7
  ]))
}